/* istanbul ignore file */
import { HttpStatusCode } from '@angular/common/http';

/**
 * This class is only intended to be used server side. It allows the `.catch()` in server.ts to know if we should issue a redirect via express.redirect()
 */
export class RedirectError {
	constructor(
		public readonly originalUrl: string,
		public readonly newUrl: string,
		public readonly statusCode: HttpStatusCode = HttpStatusCode.TemporaryRedirect
	) {}
}
